export default __webpack_public_path__ + "static/media/screen-5.8aa3596f.jpg";